import * as React from 'react';

import { TApplicationContext } from '../../../../../../node/types/application';

import { IApplyForPublicationRequest } from '../../../../../repositories/coworking/v1/apply-for-publication';
import { executeFunction } from '../../../../../utils/executeFunction';
import { AnyFunction } from '../../../../../types/AnyFunction';
import {
  EApplyForPublicationStatus,
  IApplyForPublicationStatus,
  postApplyForPublicationStatus,
} from '../../../../../services/coworking';

export type UseFetchPostApplyForPublicationCallbackMap = Partial<Record<'onRequest', AnyFunction>> &
  Partial<Record<'onSuccess' | 'onFailure' | 'onCriticalError' | 'onDone', AnyFunction<[IApplyForPublicationStatus]>>>;

export function useFetchPostApplyForPublication(
  httpApi: TApplicationContext['httpApi'],
  logger: TApplicationContext['logger'],
) {
  const [pendingState, setPendingState] = React.useState<boolean>(false);

  const callRequest = (
    parameters: IApplyForPublicationRequest,
    callback: UseFetchPostApplyForPublicationCallbackMap = Object.create(null),
  ) => {
    (async () => {
      setPendingState(true);
      const { onFailure, onSuccess, onRequest, onCriticalError, onDone } = callback;

      setPendingState(true);

      executeFunction(onRequest);

      const response = (await postApplyForPublicationStatus({
        httpApi,
        logger,
        parameters,
      })) as unknown as IApplyForPublicationStatus;

      switch (response.status) {
        case EApplyForPublicationStatus.Success:
          executeFunction(onSuccess, response);
          break;
        case EApplyForPublicationStatus.Error:
          executeFunction(onFailure, response);
          break;
        case EApplyForPublicationStatus.CriticalError:
          executeFunction(onCriticalError, response);
          break;
      }

      setPendingState(false);

      executeFunction(onDone, response);
    })();
  };

  return { callRequest, pending: pendingState };
}
